
import { Button, Table, TableBody, TableCell, TableCellLayout, TableHeader, TableHeaderCell, TableRow, tokens } from '@fluentui/react-components'
import React from 'react'



export default function TableContent({ columns, rows }: {
    columns: { name: string, key: string }[],
    rows: { name: string, value: string | JSX.Element }[]
}) {


    return (
        <>
            <div
                style={{
                    border: `1px solid ${tokens.colorNeutralStroke1}`,
                    borderRadius: "6px",
                    overflow: "hidden",
                }}
            >
                <Table>
                    <TableHeader>
                        <TableRow>
                            {columns.map((column) => (
                                <TableHeaderCell key={column.key}>{column.name}</TableHeaderCell>
                            ))}
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {rows.map((item, index) => (
                            <TableRow
                                key={item.name}
                                style={{
                                    backgroundColor: index % 2 === 0 ? tokens.colorNeutralBackground2 : tokens.colorNeutralBackground1,
                                    border: "0px solid transparent",
                                }}
                            >
                                <TableCell
                                    style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 160,
                                    }}
                                    title={item?.name}
                                >
                                    {item.name}
                                </TableCell>
                                <TableCell>{item.value}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </>
    )

}